import { baseBackend } from "../../../../api/base/baseUrl";

const RATES_GLOBAL_URL = "/api/v2/rates/global";

export async function getRatesGlobalListRequest() {
  const response = await baseBackend.get(RATES_GLOBAL_URL);
  return response.data;
}

export async function createRatesGlobalRequest(payload) {
  const response = await baseBackend.post(RATES_GLOBAL_URL, payload);
  return response.data;
}

export async function updateRatesGlobalRequest(payload) {
  const response = await baseBackend.put(RATES_GLOBAL_URL, payload);
  return response.data;
}
